import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/AdminLayout';
import api from '../../api';

const GOLD = '#D4AF37';
const BG_CARD = '#0d1117';
const BORDER = 'rgba(255,255,255,0.07)';
const TEXT_SEC = '#6b7280';
const INPUT_BG = '#0a0f1e';

const cardStyle = { background: BG_CARD, border: `1px solid ${BORDER}`, borderRadius: 16, padding: 24, marginBottom: 16 };
const inputStyle = { width: '100%', background: INPUT_BG, border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: '12px', color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' };
const btnGold = { background: GOLD, color: '#000', border: 'none', borderRadius: 10, padding: '12px 20px', fontWeight: 700, fontSize: 14, cursor: 'pointer' };
const btnGhost = { background: 'transparent', color: TEXT_SEC, border: `1px solid ${BORDER}`, borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer' };

const EMPTY = { name: '', description: '', price: '0', duration_minutes: 0, is_active: true };

export default function Addons() {
  const [addons, setAddons] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [toast, setToast] = useState('');

  useEffect(() => { load(); }, []);

  function load() { api.get('/addons').then(r => setAddons(r.data)).catch(() => {}); }
  function showToast(msg) { setToast(msg); setTimeout(() => setToast(''), 3000); }
  function openCreate() { setForm(EMPTY); setEditing(null); setShowModal(true); }
  function openEdit(a) { setForm({ ...a }); setEditing(a.id); setShowModal(true); }

  async function save(e) {
    e.preventDefault();
    try {
      if (editing) { await api.put(`/addons/${editing}`, form); }
      else { await api.post('/addons', form); }
      setShowModal(false); load();
      showToast(editing ? 'Add-on updated!' : 'Add-on created!');
    } catch { showToast('Error saving add-on'); }
  }

  async function del(id) {
    if (!window.confirm('Delete add-on?')) return;
    try { await api.delete(`/addons/${id}`); load(); showToast('Deleted'); } catch { showToast('Error'); }
  }

  return (
    <AdminLayout>
      {toast && (
        <div style={{ position: 'fixed', top: 20, right: 20, background: BG_CARD, border: `1px solid ${GOLD}`, color: GOLD, padding: '12px 20px', borderRadius: 10, zIndex: 9999, fontWeight: 600, fontSize: 14 }}>{toast}</div>
      )}
      <div style={{ maxWidth: 800 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <div>
            <h1 style={{ color: '#fff', fontSize: 24, fontWeight: 800, margin: 0 }}>Add-ons</h1>
            <p style={{ color: TEXT_SEC, fontSize: 14, margin: '4px 0 0' }}>Extra services clients can add to their booking</p>
          </div>
          <button style={btnGold} onClick={openCreate}>+ New Add-on</button>
        </div>

        {showModal && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
            <div style={{ ...cardStyle, width: '100%', maxWidth: 480, marginBottom: 0 }}>
              <h3 style={{ color: GOLD, margin: '0 0 20px', fontSize: 16 }}>{editing ? 'Edit Add-on' : 'New Add-on'}</h3>
              <form onSubmit={save}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                  <div>
                    <label style={{ color: TEXT_SEC, fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 6 }}>NAME *</label>
                    <input style={inputStyle} value={form.name} onChange={e => setForm({...form, name: e.target.value})} required placeholder="e.g. Deep Facial, Beard Line-up" />
                  </div>
                  <div>
                    <label style={{ color: TEXT_SEC, fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 6 }}>DESCRIPTION</label>
                    <input style={inputStyle} value={form.description || ''} onChange={e => setForm({...form, description: e.target.value})} placeholder="Short description..." />
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                    <div>
                      <label style={{ color: TEXT_SEC, fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 6 }}>PRICE ($)</label>
                      <input style={inputStyle} type="number" step="0.01" min="0" value={form.price} onChange={e => setForm({...form, price: e.target.value})} placeholder="10.00" />
                    </div>
                    <div>
                      <label style={{ color: TEXT_SEC, fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 6 }}>EXTRA DURATION (min)</label>
                      <input style={inputStyle} type="number" min="0" value={form.duration_minutes} onChange={e => setForm({...form, duration_minutes: parseInt(e.target.value) || 0})} placeholder="15" />
                    </div>
                  </div>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', color: TEXT_SEC, fontSize: 13 }}>
                    <input type="checkbox" checked={form.is_active} onChange={e => setForm({...form, is_active: e.target.checked})} />
                    Active (visible in booking flow)
                  </label>
                </div>
                <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
                  <button type="submit" style={btnGold}>{editing ? 'Save Changes' : 'Create Add-on'}</button>
                  <button type="button" style={btnGhost} onClick={() => setShowModal(false)}>Cancel</button>
                </div>
              </form>
            </div>
          </div>
        )}

        <div style={{ display: 'grid', gap: 12 }}>
          {addons.length === 0 ? (
            <div style={{ ...cardStyle, textAlign: 'center', padding: '48px 24px' }}>
              <p style={{ color: TEXT_SEC }}>No add-ons yet. Create extras like facials, beard trims, or treatments.</p>
            </div>
          ) : addons.map(a => (
            <div key={a.id} style={{ ...cardStyle, marginBottom: 0, display: 'flex', alignItems: 'center', gap: 16 }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
                  <span style={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>{a.name}</span>
                  {!a.is_active && <span style={{ color: TEXT_SEC, background: 'rgba(255,255,255,0.05)', borderRadius: 4, padding: '1px 8px', fontSize: 11 }}>INACTIVE</span>}
                </div>
                {a.description && <p style={{ color: TEXT_SEC, fontSize: 13, margin: '0 0 6px' }}>{a.description}</p>}
                <div style={{ display: 'flex', gap: 16, color: TEXT_SEC, fontSize: 12 }}>
                  <span style={{ color: GOLD, fontWeight: 700 }}>+${parseFloat(a.price || 0).toFixed(2)}</span>
                  {a.duration_minutes > 0 && <span>+{a.duration_minutes} min</span>}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button style={{ ...btnGhost, fontSize: 12 }} onClick={() => openEdit(a)}>Edit</button>
                <button style={{ ...btnGhost, color: '#ef4444', borderColor: '#ef444444', fontSize: 12 }} onClick={() => del(a.id)}>Delete</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
}
